import React, { useContext } from "react";
import { Redirect, Route, Switch } from "react-router";
import Layout from "../../Layout";
import MenuManagementPage from "../MenuManagementPage";
import NewsManagementPage from "../NewsManagementPage";
import menu from "./menu";
import {
  PermissionContext,
  Roles,
  withPermission,
} from "../../../util/PermissionProvider";
import CallForEntryDetailPage from "../CallForEntryDetailPage";
import CallForEntryListingPage from "../CallForEntryListingPage";
import InvitedEntryDetailPage from "../InvitedEntryDetailPage";
import InvitedEntryListingPage from "../InvitedEntryListingPage";
import EntryEmailConfigurationPage from "../EntryEmailConfigurationPage";
import GuestAccreditationPage from "../AccreditationPages/GuestAccreditationListing";
import GuestAccreditationDetailPage from "../AccreditationPages/GuestAccreditationDetail";
import MediaAccreditationPage from "../AccreditationPages/MediaAccreditationListing";
import MediaAccreditationDetailPage from "../AccreditationPages/MediaAccreditationDetail";
import RefundPages from "../RefundPages";
import LogoPages from "../LogoPages";
import BannerListingPage from "../BannerListingPage";
import BannerDetailPage from "../BannerDetailPage";
import EDMListingPage from "../EDMPages/EDMListingPage";
import EDMEditPage from "../EDMPages/EDMEditPage";
import RegionManagementListingPage from "../RegionManagementPage/RegionManagementListingPage";
import RegionManagementEditPage from "../RegionManagementPage/RegionManagementEditPage";
import DistrictEditPage from "../RegionManagementPage/DistrictEditPage";
import VenueEditPage from "../RegionManagementPage/VenueEditPage";
import FestivalDailyListingPage from "../FestivalDailyListingPage";
import FestivalDailyDetailPage from "../FestivalDailyDetailPage";
import SponsorsListingPage from "../SponsorsManagementPage/SponsorsListingPage";
import SponsorsCategoryListingPage from "../SponsorsManagementPage/SponsorsCategoryListingPage";
import SponsorsEditPage from "../SponsorsManagementPage/SponsorsEditPage";
import SponsorsCategoryEditPage from "../SponsorsManagementPage/SponsorsCategoryEditPage";
import SubscriptionListPage from "../SubscriptionListingPage";
import MemberListingPage from "../MemberManagementPages/MemberListingPage";
import MemberDetailPage from "../MemberManagementPages/MemberDetailPage";
import MemberRecordPage from "../MemberManagementPages/MemberRecordPage";
import MemberPlanListingPage from "../MemberManagementPages/MemberPlanListingPage";
import MemberGiftListingPage from "../MemberManagementPages/MemberGiftListingPage";
import MemberConfigurationPage from "../MemberManagementPages/MemberConfigurationPage";
import MemberEmailSettingsPage from "../MemberManagementPages/MemberEmailSettingsPage";
import MemberPlanDetailPage from "../MemberManagementPages/MemberPlanDetailPage";
import MemberGiftDetailPage from "../MemberManagementPages/MemberGiftDetailPage";
import TicketListingPage from "../TicketListingPage";
import TicketDetailPage from "../TicketDetailPage";
import FaqListingPage from "../FaqListingPage";
import FaqDetailPage from "../FaqDetailPage";
import FestivalPassNoticePage from "../FestivalPassNoticePage";
import FestivalPassDetailPage from "../FestivalPassDetailPage";
import FestivalPassListingPage from "../FestivalPassListingPage";
import FilmListingPage from "../FilmListingPage";
import FilmCategoryPage from "../FilmCategoryPage";
import FilmSubCategoryEditPage from "../FilmCategoryPage/editPage";
import FilmDetailPage from "../FilmDetailPage";
import FilmTagPage from "../FilmTagPage";
import FilmTagEditPage from "../FilmTagPage/editPage";
import FilmIconPage from "../FilmIconPage";
import FilmIconEditPage from "../FilmIconPage/editPage";
import AwardJuriesPages from "../AwardJuriesPages";
import JuriesListingPage from "../JuriesListingPage";
import JuriesEditPage from "../JuriesListingPage/JuriesEditPage";
import OrganizationPages from "../OrganizationPages";
import EventCategoryPage from "../EventPages/EventCategoryListing";
import EShopPages from "../EShopPages";
import ProgrammePages from "../ProgrammePages";
import HistoryCulturePage from "../HistoryCulturePage";
import CompanyProfilePage from "../CompanyProfilePage";
import SupportUsListingPage from "../SupportUsListingPage";
import SupportUsDetailPage from "../SupportUsDetailPage";
import ContactUsPage from "../ContactUsPage";
import JobPages from "../JobPages";
import {
  EventListingPage,
  EventDetailPage,
  EventCategoryDetailPage,
} from "../EventPages";
import ReportPages from "../ReportPages";
import HkiffListingPage from "../HkiffListingPage";
import HkiffDetailPage from "../HkiffDetailPage";
import AcaPages from "../AcaPages";

export default function HKIFFSection(props) {
  const { match } = props;
  const { userPermissions } = useContext(PermissionContext);
  console.log(match.url);
  return (
    userPermissions && (
      <Layout menuObj={menu}>
        <Switch>
          <Route
            exact
            path={`${match.url}/banner`}
            component={withPermission(
              BannerListingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/banner/:id`}
            component={withPermission(
              BannerDetailPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/subscription`}
            component={withPermission(
              SubscriptionListPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/ticket-and-faq/ticketing`}
            component={withPermission(
              TicketListingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/ticket-and-faq/ticketing/:id`}
            component={withPermission(
              TicketDetailPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/ticket-and-faq/faq`}
            component={withPermission(
              FaqListingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/ticket-and-faq/faq/:id`}
            component={withPermission(
              FaqDetailPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/ticket-and-faq/festival-pass`}
            component={withPermission(
                FestivalPassListingPage,
                [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
                [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/ticket-and-faq/festival-pass/:id`}
            component={withPermission(
                FestivalPassDetailPage,
                [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
                [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/ticket-and-faq/festival-pass-notice`}
            component={withPermission(
              FestivalPassNoticePage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/membership/member`}
            component={withPermission(
              MemberListingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/membership/member/:id`}
            component={withPermission(
              MemberDetailPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/membership/member/record/:id`}
            component={withPermission(
              MemberRecordPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/membership/plan`}
            component={withPermission(
              MemberPlanListingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/membership/plan/:id`}
            component={withPermission(
              MemberPlanDetailPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/membership/gift`}
            component={withPermission(
              MemberGiftListingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/membership/gift/:id`}
            component={withPermission(
              MemberGiftDetailPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/membership/configuration`}
            component={withPermission(
              MemberConfigurationPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/membership/email`}
            component={withPermission(
              MemberEmailSettingsPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/banner/create/:type`}
            component={withPermission(
              BannerDetailPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/call-for-entry`}
            component={withPermission(
              CallForEntryListingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            path={`${match.url}/call-for-entry/:id`}
            component={withPermission(
              CallForEntryDetailPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/event`}
            component={withPermission(
              EventListingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            path={`${match.url}/event/category/:id`}
            component={withPermission(
              EventCategoryDetailPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            path={`${match.url}/event/:id`}
            component={withPermission(
              EventDetailPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/film`}
            component={withPermission(
              FilmListingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/film/:id`}
            component={withPermission(
              FilmDetailPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/film-category`}
            component={withPermission(
              FilmCategoryPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/film-category/:catId`}
            component={withPermission(
              FilmCategoryPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/film-category/:catId/:subCatId`}
            component={withPermission(
              FilmSubCategoryEditPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/film-tag`}
            component={withPermission(
              FilmTagPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/film-tag/:id`}
            component={withPermission(
              FilmTagEditPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/film-icon`}
            component={withPermission(
              FilmIconPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/film-icon/:id`}
            component={withPermission(
              FilmIconEditPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/awards/juries`}
            component={withPermission(
              JuriesListingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/awards/juries/:id`}
            component={withPermission(
              JuriesEditPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/festival-daily`}
            component={withPermission(
              FestivalDailyListingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/festival-daily/:id`}
            component={withPermission(
              FestivalDailyDetailPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/sponsors`}
            component={withPermission(
              SponsorsListingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/sponsors/:id`}
            component={withPermission(
              SponsorsEditPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/sponsors-category`}
            component={withPermission(
              SponsorsCategoryListingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            path={`${match.url}/sponsors-category/:id`}
            component={withPermission(
              SponsorsCategoryEditPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/invited-entry`}
            component={withPermission(
              InvitedEntryListingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            path={`${match.url}/invited-entry/:id`}
            component={withPermission(
              InvitedEntryDetailPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            path={`${match.url}/entry-email-config`}
            component={withPermission(
              EntryEmailConfigurationPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            // exact
            path={`${match.url}/menu`}
            component={MenuManagementPage}
          />
          <Route path={`${match.url}/news`} component={NewsManagementPage} />
          <Route
            exact
            path={`${match.url}/edm`}
            component={withPermission(
              EDMListingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            path={`${match.url}/edm/:id`}
            component={withPermission(
              EDMEditPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/region-management/:type`}
            component={withPermission(
              RegionManagementListingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            path={`${match.url}/region-management/region/:id`}
            component={withPermission(
              RegionManagementEditPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            path={`${match.url}/region-management/district/:id`}
            component={withPermission(
              DistrictEditPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            path={`${match.url}/region-management/venue/:id`}
            component={withPermission(
              VenueEditPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/guest-accreditation`}
            component={withPermission(
              GuestAccreditationPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/guest-accreditation/email-template`}
            component={withPermission(
              GuestAccreditationPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            path={`${match.url}/guest-accreditation/email-template/:id`}
            component={withPermission(
              GuestAccreditationPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            path={`${match.url}/guest-accreditation/:id`}
            component={withPermission(
              GuestAccreditationDetailPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/media-accreditation`}
            component={withPermission(
              MediaAccreditationPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER, Roles.HKIFF_MA_EDITOR],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_MA_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/media-accreditation/email-template`}
            component={withPermission(
              MediaAccreditationPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER, Roles.HKIFF_MA_EDITOR],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_MA_EDITOR]
            )}
          />
          <Route
            path={`${match.url}/media-accreditation/email-template/:id`}
            component={withPermission(
              MediaAccreditationPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER, Roles.HKIFF_MA_EDITOR],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_MA_EDITOR]
            )}
          />
          <Route
            path={`${match.url}/media-accreditation/:id`}
            component={withPermission(
              MediaAccreditationDetailPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER, Roles.HKIFF_MA_EDITOR],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_MA_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/event/category`}
            component={withPermission(
              EventCategoryPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/event`}
            component={withPermission(
              EventCategoryPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            path={`${match.url}/event/category/:id`}
            component={withPermission(
              EventCategoryDetailPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            path={`${match.url}/organization`}
            component={OrganizationPages}
          />
          <Route path={`${match.url}/refund`} component={RefundPages} />
          <Route path={`${match.url}/eshop`} component={EShopPages} />
          <Route path={`${match.url}/programme`} component={ProgrammePages} />
          <Route path={`${match.url}/awards`} component={AwardJuriesPages} />
          <Route path={`${match.url}/aca`} component={AcaPages} />
          <Route
            exact
            path={`${match.url}/history-culture`}
            component={withPermission(
              HistoryCulturePage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/hkiff`}
            component={withPermission(
              HkiffListingPage,

              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/company-profile`}
            component={withPermission(
              CompanyProfilePage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/hkiff/:id`}
            component={withPermission(
              HkiffDetailPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/support-us`}
            component={withPermission(
              SupportUsListingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            path={`${match.url}/support-us/:id`}
            component={withPermission(
              SupportUsDetailPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/contact-us`}
            component={withPermission(
              ContactUsPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route path={`${match.url}/job-opportunity`} component={JobPages} />
          <Route path={`${match.url}/logos`} component={LogoPages} />
          <Route path={`${match.url}/report`} component={ReportPages} />
          <Route
            render={() => <Redirect to={`${match.url}/call-for-entry`} />}
          />
        </Switch>
      </Layout>
    )
  );
}
